import de from './de.json';

export default {
    de
};